<template>
    <b-modal
        v-if="Object.keys(model).length"
        v-model="modalTrigger"
        :title="`Editing property for: ${tag}`"
        @ok="saveHandler()"
    >
        <b-form-group label="Render as" class="mb-3">
            <b-form-radio-group
                v-model="model.renderOption"
                :options="typeOptions"
                name="radio-inline"
            ></b-form-radio-group>
        </b-form-group>

        <b-form-group
            class="mb-3"
            label="Property type"
            label-for="propety-type"
            description="Attribute value type"
        >
            <b-form-select
                d="propety-type"
                v-model="model.type"
                :options="typeSelectOptions"
            ></b-form-select>
        </b-form-group>

        <b-form-group
            class="mb-3"
            label="Property name"
            label-for="propety-name"
            description="Attribute on the component"
        >
            <b-form-input
                id="propety-name"
                v-model="model.name"
                placeholder="Property"
            ></b-form-input>
        </b-form-group>

        <b-form-group
            v-if="model.renderOption !== 'noValue'"
            class="mb-3"
            label="Value"
            label-for="propety-value"
            description="Attribute's value on the component"
        >
            <b-form-radio-group
                v-if="model.renderOption === 'boolean'"
                v-model="model.value"
                :options="boolOptions"
                name="value-radio-inline"
            ></b-form-radio-group>
            <template v-else>
                <b-form-input
                    class="mb-1"
                    id="propety-value"
                    v-model="model.value"
                    :placeholder="model.defaultValue.toString()"
                ></b-form-input>
                <b-form-checkbox
                    :key="`a-${dbgKey}`"
                    v-if="model.renderOption === 'dynamic'"
                    id="checkbox-1"
                    class="mb-1"
                    v-model="model.requiresSpecial"
                    value="data"
                    name="checkbox-1"
                    @click.native="relaodDbg()"
                    >Requires "data"</b-form-checkbox
                >
                <b-form-checkbox
                    :key="`2-${dbgKey}`"
                    v-if="model.renderOption === 'dynamic'"
                    id="checkbox-2"
                    class="mb-1"
                    v-model="model.requiresSpecial"
                    value="computed"
                    name="checkbox-2"
                    @click.native="relaodDbg()"
                    >Requires "computed"</b-form-checkbox
                >
                <b-form-checkbox
                    v-if="model.renderOption === 'listener'"
                    id="checkbox-3"
                    class="mb-1"
                    v-model="model.requiresMethod"
                    name="checkbox-3"
                    @click.native="relaodDbg()"
                    >Requires "method"</b-form-checkbox
                >
            </template>
        </b-form-group>

        <b-form-group
            v-if="model.renderOption !== 'noValue'"
            class="mb-3"
            label="Default value"
            label-for="default-value"
            description="Attribute's default value on the component if used as root"
        >
            <b-form-input
                id="default-value"
                v-model="model.defaultValue"
                placeholder="Default value"
            ></b-form-input>
        </b-form-group>

        <!-- if dynamic then show more options -->
        <div class="d-flex w-100">
            <a
                href="#"
                variant="link"
                @click.prevent="dbg = !dbg"
                class="ml-auto small"
                >{{ dbg ? "Hide" : "Show" }} debug info</a
            >
        </div>
        <template v-if="dbg">
            <div :key="dbgKey">
                old:
                <pre class="mt-3 small text-muted bg-light rounded">{{
                    value
                }}</pre>
                new:
                <pre class="mt-3 small text-muted bg-light rounded">{{
                    model
                }}</pre>
            </div>
        </template>

        <footer slot="modal-footer" class="d-flex w-100">
            <button
                type="button"
                class="btn btn-danger mr-auto"
                @click="removeHandler()"
            >
                Remove
            </button>
            <button
                type="button"
                class="btn btn-secondary mx-1"
                @click="modalTrigger = false"
            >
                Cancel
            </button>
            <button
                type="button"
                class="btn btn-primary"
                @click="saveHandler()"
            >
                OK
            </button>
        </footer>
    </b-modal>
</template>
<script>
export default {
    name: "propertyEditor",
    props: {
        value: {
            type: Object,
            default: () => {}
        },
        tag: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            dbg: false,
            dbgKey: 0,
            typeOptions: [
                { text: "static value", value: "static" },
                { text: "dynamic binding", value: "dynamic" },
                { text: "bool value", value: "boolean" },
                { text: "without value", value: "noValue" },
                { text: "event listener", value: "listener" },
                { text: "HTML attribute", value: "htmlAttribute" }
            ],
            typeSelectOptions: [
                { value: "String", text: "String" },
                { value: "Boolean", text: "Boolean" },
                { value: "Number", text: "Number" },
                { value: "Object", text: "Object" },
                { value: "Array", text: "Array" }
            ],
            boolOptions: [
                { text: "FALSE", value: "false" },
                { text: "TRUE", value: "true" }
            ],
            modalTrigger: false,
            defaultHTMLAttributes: [
                "alt",
                "name",
                "class",
                "style",
                "title",
                "tabindex"
            ],
            selected: null,
            model: {}
        };
    },
    methods: {
        open() {
            this.laodEntry(this.value);
            this.modalTrigger = true;
        },
        laodEntry(value) {
            if (Object.keys(value).length) {
                this.model = Object.assign({}, value);
            }
        },
        saveHandler() {
            this.modalTrigger = false;
            this.$emit("saved", { old: this.value, new: this.model });
        },
        removeHandler() {
            this.modalTrigger = false;
            this.$emit("removed", { prop: this.value });
        },
        relaodDbg() {
            setTimeout(() => {
                this.dbgKey++;
            }, 0);
        }
    },
    watch: {
        value(val) {
            this.laodEntry(val);
        },
        model: {
            handler(val) {
                if (val) {
                    if (val.renderOption !== "dynamic") {
                        delete this.model.requiresSpecial;
                    } else if (this.model.requiresSpecial === undefined) {
                        this.model.requiresSpecial = false;
                    }

                    if (val.renderOption === "noValue") {
                        delete this.model.value;
                    }
                }
            },
            deep: true
        }
    }
};
</script>
